module.exports = __webpack_public_path__ + "static/media/combined-shape.73dce532.png";